import axios from "axios";

export const getItems = async (env: string) => {
  const environment = env?.toUpperCase() === "DEV" ? "PRD" : env?.toUpperCase();
  const response = await axios({
    method: "GET",
    url: `https://cdn-delivery.autodesk.com/items/${environment}/fullitemcatalog.json`,
    headers: {
      "Content-Type": "application/json"
    }
  });
  return response?.data?.length
    ? response?.data?.filter((item: Record<string, any>) => {
        const classification = item?.classification?.toLowerCase();
        const lifecycleState = item?.itemData?.lifecycleState?.toLowerCase();
        const downloadUrl = item?.extraData?.downloadUrl?.toLowerCase();

        // Adding conditions as discussed https://autodesk.slack.com/archives/C05RLJZRRR9/p1721159567084589
        return ["assigned", "orderable", "pre-assigned"].includes(lifecycleState) && (classification === "sp" || classification === "ss" || classification === "sb");
      })
    : [];
};
